import { gql } from '@apollo/client'
import INTERACTIONS from 'apollo/queries/INTERACTIONS'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation updateInteraction(
    $id: ID!
    $attributes: UpdateInteractionAttributesInput!
  ) {
    updateInteraction(id: $id, attributes: $attributes) {
      id
      ticket {
        id
      }
    }
  }
`

export default function useInteractionUpdate(successMessage = '') {
  const { onMutate: onInteractionUpdate, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'updateInteraction',
    successMessage,
    refetchQueries: ({ data }) => {
      const ticketId = data?.updateInteraction?.ticket?.id
      if (!ticketId) return null

      return [
        {
          query: INTERACTIONS,
          variables: {
            first: 25,
            filters: {
              ticket_ids: [ticketId]
            }
          }
        }
      ]
    }
  })

  return { onInteractionUpdate, loading }
}
